import type { ColorIndicatorColor } from "@slfinrtl/ui-bff-routes"
import { TagIcon } from "../tagIcon/TagIcon"
import type { TagIconProps } from "../tagIcon/TagIcon"
import increase1 from "./icons/increase-1.svg"
import increase2 from "./icons/increase-2.svg"
import increase3 from "./icons/increase-3.svg"

const colorMap: Record<Exclude<ColorIndicatorColor, "green">, TagIconProps["color"]> = {
	red: "error",
	yellow: "warning",
}

const iconMap: Record<ColorIndicatorColor, string> = {
	green: increase3,
	red: increase1,
	yellow: increase2,
}

interface ListingScoreColorIndicatorProps {
	className?: string
	color: ColorIndicatorColor
}

export const ListingScoreIcon = ({ color, ...rest }: ListingScoreColorIndicatorProps) => {
	return <TagIcon color={colorMap[color as keyof typeof colorMap]} iconSource={iconMap[color]} {...rest} />
}
